export class AsuSmrReportFilters{
    startAwardYear : string;
    endAwardYear : string;
    status : any;
    competitors : any;
    segments: any;
    constructor(startAwardYear,endAwardYear,status,competitors,segments){
        this.startAwardYear = startAwardYear;
        this.endAwardYear = endAwardYear;
        this.status = status;
        this.competitors = competitors;
        this.segments = segments;
    }
}